import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import useAnchor, { anchorHref } from 'components/hooks/useAnchor';
import { LOGIN_URL } from 'src/constants/misc';

import { DemoButton } from '../DemoModal';
import LanguageSwitcher from '../LanguageSwitcher';
import Logo from '../Logo';

import style from './Header.module.scss';

const LINKS = [
  { hash: '#agent', label: 'navigation.agent' },
  { hash: '#jak', label: 'navigation.how' },
  { hash: '#wyniki', label: 'navigation.results' },
  { hash: '#faq', label: 'navigation.faq' }
];

// partner: { name, logoOnDark, logoOnLight } shown next to the Avalio logo
const Header = ({ homePath = '/', partner, ctaLabel }) => {
  const { t } = useTranslation();
  const onAnchorClick = useAnchor(homePath);

  const logo = (
    <a
      className={style.logo}
      href={anchorHref('#hero', homePath)}
      aria-label={t('navigation.home')}
      onClick={onAnchorClick}
    >
      <Logo />
    </a>
  );

  return (
    <header className={style.nav}>
      <div
        className={cn(style.navIn, partner && style.withPartner)}
        data-nav-bar
      >
        {partner ? (
          <div className={style.brandPair}>
            {logo}
            <span
              className={style.brandX}
              aria-hidden='true'
            >
              ×
            </span>
            <span className={style.partnerLogo}>
              <img
                className={style.onDark}
                src={partner.logoOnDark}
                alt={partner.name}
                width='155'
                height='20'
              />
              <img
                className={style.onLight}
                src={partner.logoOnLight}
                alt=''
                aria-hidden='true'
                width='155'
                height='20'
              />
            </span>
          </div>
        ) : (
          logo
        )}
        <nav
          className={style.links}
          aria-label={t('navigation.main')}
        >
          {LINKS.map(({ hash, label }) => (
            <a
              key={hash}
              href={anchorHref(hash, homePath)}
              onClick={onAnchorClick}
            >
              {t(label)}
            </a>
          ))}
        </nav>
        <LanguageSwitcher className={style.lang} />
        <a
          className={style.login}
          href={LOGIN_URL}
        >
          {t('navigation.login')}
        </a>
        <DemoButton className={style.cta}>{ctaLabel || t('navigation.bookDemo')}</DemoButton>
      </div>
    </header>
  );
};

export default Header;
